import { es } from './es'
import { pt } from './pt'
import { en } from './en'

export const messagesGlobal = {
  es,
  pt,
  en
}
